import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, programManagementURL } from '../../../../../Containers/Config/index.js';
import { GET_MASTER_CONFIGS, GET_MASTER_CONFIGS_ERROR, GET_MASTER_CONFIGS_SUCCESS } from '../../../actionType.js';
import apiCall from '../../../apiCall.js';

function* getMasterConfigs({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${programManagementURL}/api/v1/master/configs`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: payload?.urlParam,
    });

    if (response.status === 200) {
      yield put({
        type: GET_MASTER_CONFIGS_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_MASTER_CONFIGS_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_MASTER_CONFIGS_ERROR, payload: error });
  }
}

export function* watchGetMasterConfigs() {
  yield takeEvery(GET_MASTER_CONFIGS, getMasterConfigs);
}

function* getMasterConfigsSaga() {
  yield all([fork(watchGetMasterConfigs)]);
}

export default getMasterConfigsSaga;
